class Search {
    constructor(item) {
        // Переменные
        this.element = item;
        this.tabs = this.element.querySelectorAll('.js-search-tab');
        this.inners = this.element.querySelectorAll('.js-search-inner');
        this.currentIndex = 0;

        // Функции
        this.setListeners();
    };

    setListeners() {
        this.tabs.forEach((item, index) => {
            item.addEventListener('click', () => {
                // Добавляем класс активному табу
                item.classList.add('is-active');
                this.currentIndex = index;

                // Удаляем класс у неактивных табов
                this.tabs.forEach((item2, index2) => {
                    if (index2 != this.currentIndex) {
                        item2.classList.remove('is-active');
                    }
                });

                // Добавляем класс содержимому
                this.inners.forEach((item2, index2) => {
                    if (index2 != this.currentIndex) {
                        item2.classList.remove('is-active');
                    } else {
                        item2.classList.add('is-active');
                    }
                });
            });
        });
    }
};

document.querySelectorAll('.js-search').forEach((item) => new Search(item));
